import React from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import { get } from "lodash";
import {
  formatNumberOnDashBoard,
  getLocalstorage,
  isValidArray,
  setLocalstorage
} from "../../../helper";
import { connect } from "react-redux";
import { STATUS } from "../../../constant";
import NoDataFound from "../../../component/NoDataFound";
import AppliedFilters from "../AppliedFilterDisplay";
import { getDistrictDepartmentByParentIds } from "../../../actions/mis.action";
import { bindActionCreators } from "redux";
import { fetchProjectReport } from "../../../actions/mis.action";

class ProjectSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filtersAfterDeletion: getLocalstorage("projectSummaryFilters")
    };
  }

  deleteFilter = (filter, index) => {
    let appliedFilters = getLocalstorage("projectSummaryFilters");
    appliedFilters.splice(index, 1);
    const newFilters = setLocalstorage("projectSummaryFilters", appliedFilters);
    this.setState({ filtersAfterDeletion: newFilters }, this.onDeletingFilters);
  };

  onDeletingFilters = () => {
    const { fetchProjectReport, onClearProjectFilter } = this.props;
    const newRemainingFilters = getLocalstorage("projectSummaryFilters");
    const results = {};

    newRemainingFilters.forEach(({ value, optionName }) => {
      if (
        optionName === "multiStateProject" ||
        optionName === "implementationMode" ||
        optionName === "monitoring" ||
        optionName === "projectStatus"
      ) {
        results[optionName] = results[optionName] || [];
        if (!results[optionName].includes(value)) {
          results[optionName].push(value);
        }
      } else if (optionName === "createdDate") {
        results[optionName] = value;
      } else if (optionName === "projectCost") {
        results[optionName] = [value];
      } else {
        results[optionName] = results[optionName] || [];
        const numValue = parseInt(value);
        if (!results[optionName].includes(numValue)) {
          results[optionName].push(numValue);
        }
      }
    });

    fetchProjectReport(results);
    onClearProjectFilter(true);
  };

  removeAllFilters = () => {
    const { fetchProjectReport } = this.props;
    let appliedFilters = setLocalstorage("projectSummaryFilters", null);
    fetchProjectReport(appliedFilters);
  };

  render() {
    const { misData, misFlatFileStatus } = this.props;

    return (
      <React.Fragment>
        <div className="mis-list">
          <AppliedFilters
            deleteFilter={this.deleteFilter}
            filters={getLocalstorage("projectSummaryFilters") || []}
          />
          {getLocalstorage("projectSummaryFilters") !== null &&
            getLocalstorage("projectSummaryFilters").length >= 2 && (
              <div
                className="clear-all-filters"
                onClick={this.removeAllFilters}
              >
                Clear All
              </div>
            )}
        </div>

        <Table striped size="sm" className="mis-project-list table-striped">
          <thead>
            <tr>
              <th className="project-id-column">Project ID</th>
              <th className="project-name-column">Project Name</th>
              <th className="project-ministry-column">Ministry</th>
              <th className="project-date-column">Created Date</th>
              <th className="project-cost-column">Cost(cr)</th>
            </tr>
          </thead>
          <tbody>
            {misFlatFileStatus === STATUS.LOADING ? (
              <tr>
                <td colSpan="7">
                  <NoDataFound />
                </td>
              </tr>
            ) : isValidArray(get(misData, "data")) ? (
              misData.data.map((data, index) => {
                let date =
                  (get(data, "projectCreatedOn") &&
                    data.projectCreatedOn.split(" ")[0]) ||
                  null;
                return (
                  <tr>
                    <td className="project-id-column">{data.id}</td>
                    <td className="project-name-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {data.title}
                          </Tooltip>
                        }
                      >
                        <div>{data.title}</div>
                      </OverlayTrigger>
                    </td>
                    <td className="project-ministry-column">
                      <OverlayTrigger
                        placement="bottom-start"
                        key="bottom"
                        overlay={
                          <Tooltip
                            id="tooltip-bottom"
                            className="mis-tooltip"
                            placement="bottom-start"
                          >
                            {data.group}
                          </Tooltip>
                        }
                      >
                        <div>{data.group}</div>
                      </OverlayTrigger>
                    </td>
                    <td className="project-date-column">{date}</td>
                    <td className="project-cost-column">
                      {(data.projectCost &&
                        formatNumberOnDashBoard(data.projectCost)) ||
                        "NA"}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="7">
                  <NoDataFound />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    misFlatFileStatus: state.misReducer.misFlatFileStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getDistrictDepartmentByParentIds,
      fetchProjectReport
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectSummary);
